<template>
    <div
        v-if="htmlstring"
        class="appear"
        style="z-index: 100; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.8);"
        @click.stop.prevent="hide"
    >
        <div
            style="position: absolute; right: 10%; top: 10%; z-index: 10; margin-right: -50px;"
            @click="hide"
        >
            <span class="btn btn-danger">
                <span class="fa fa-times fa-lg" />
            </span>
        </div>
        <div style="position: fixed;  right: 10%; top: 10%; bottom: 10%; overflow-y: scroll; overflow-x: hidden; max-width: 800px; min-width: 700px; background-color: #ffffff;">
            <div v-html="htmlstring" />
        </div>
    </div>
    <div v-else />
</template>

<script>
    export default {
        name: 'EmailPreview',
        props: {
            htmlstring: {
                type: String,
                default: '',
            },
        },
        data: function() {
            return {
            }
        },
        watch: {
        },
        mounted: function() {
        },
        methods: {
            hide: function() {
                this.$emit('close');
            }
        },
    }
</script>

